import { Divider, Stack, Typography } from "@mui/material";
import React, { FC } from "react";
import { JsonObject } from "type-fest";
import { OptionGroupAttributes } from "../../../../Domains/OptionGroups/api/optionGroupsApi.ts";
import { Link } from "react-router";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

type AutocompleteRenderOptionProps<T extends JsonObject> = {
  option: T;
};

export const RenderOption: FC<AutocompleteRenderOptionProps<OptionGroupAttributes>> = ({ option }) => {
  const isInactiveOptionGroup = !option.is_active_in_pos && !option.is_active_in_jamezz;

  return (
    <Stack
      direction={"column"}
      alignItems={"stretch"}
      sx={{ color: isInactiveOptionGroup ? "grey" : undefined }}
      flex={1}
    >
      <Stack direction={"row"} justifyContent={"space-between"} sx={{ width: 1 }}>
        <Typography component={"span"} sx={{ textDecoration: isInactiveOptionGroup ? "line-through" : undefined }}>
          {option.name}
        </Typography>
        <Link
          to={`/manager/optionGroups/${option.id}/edit?tabIndex=0`}
          target={"_blank"}
          onClick={(e) => e.stopPropagation()}
        >
          <OpenInNewIcon sx={{ color: "grey" }} />
        </Link>
      </Stack>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography component={"span"} color={"grey"} sx={{ gridArea: "id" }}>
          #{option.id}
        </Typography>
      </Stack>
      <Divider sx={{ gridArea: "divider" }} />
    </Stack>
  );
};
